var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNuqleaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1500 348.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#000006;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logos"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "911.09 252.28 911.09 3.73 865.49 3.73 865.49 243.44 865.49 292.67 911.09 292.67 1013.85 292.67 1013.85 252.28 911.09 252.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1207.6 44.11 1207.6 3.73 1099.04 3.73 1099.04 3.62 1053.44 3.62 1053.44 3.73 1053.44 52.95 1053.44 126.09 1053.44 175.31 1053.44 243.44 1053.44 292.67 1099.04 292.67 1207.6 292.67 1207.6 252.28 1099.04 252.28 1099.04 170.79 1186.19 170.79 1186.19 130.41 1099.04 130.41 1099.04 44.11 1207.6 44.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1450.2,292.67h49.8L1391.24,3.86l.09-.24h-41.99l.09,.24-108.76,288.81h49.8l26.99-74.55h105.75l26.99,74.55Zm-118.12-114.94l38.25-105.66,38.25,105.66h-76.51Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "183.91 3.67 183.91 216.42 48.5 3.67 45.6 3.67 7.33 3.67 0 3.67 0 292.61 45.6 292.61 45.6 84.41 181 292.61 183.91 292.61 223.73 292.61 229.51 292.61 229.51 3.67 183.91 3.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M742.33,16.53c-72.08-37.37-160.79-9.23-198.16,62.85-36.42,70.25-10.6,156.29,57.45,195.21l-.06,.12,142.65,73.95,18.59-35.86-131.05-72.02c-1.52-.7-3.03-1.43-4.53-2.2-50.56-26.21-70.3-88.45-44.09-139.01,26.21-50.56,88.45-70.3,139.01-44.09,50.56,26.21,70.3,88.45,44.09,139.01-14.3,27.58-39.32,45.96-67.31,52.75l48.75,27.38c23.74-13.55,43.99-33.85,57.51-59.93,37.37-72.08,9.23-160.79-62.85-198.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M384.32,293.24c-55.61,0-100.85-39.39-100.85-87.81V3.73h43.55V205.44c0,24.4,25.71,44.25,57.3,44.25s57.3-19.85,57.3-44.25V3.73h43.55V205.44c0,48.42-45.24,87.81-100.85,87.81Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNuqleaLogo);
export default __webpack_public_path__ + "static/media/nuqlea-logo.679b1a115184693d6706453ef8b8f0e2.svg";
export { ForwardRef as ReactComponent };